import { withStyles } from '@material-ui/core';

import Popup from './component';
import styles from './styles';

export default withStyles(styles)(Popup);
